import { APP_ROLES } from '@/config/config';

export const PAGE_AGENT_ALLOWED_ROLES = [
  APP_ROLES.SUPER_ADMIN,
  APP_ROLES.ADMIN,
  APP_ROLES.PARTNER,
  APP_ROLES.MERCHANT,
  APP_ROLES.CHANNEL,
];
